export default __webpack_public_path__ + "static/axie-infinity-7850e2ff762016d8f8b79eed7522b38e.png";